// Module
var code = `<div class="page-item--testimonials">
  <h2 class="testimonials-title">{{title}}</h2>
  <div class="testimonials-grid">
    {{#items}}
    <figure class="testimonial">
      <blockquote class="testimonial-quote">{{quote}}</blockquote>
      <figcaption class="testimonial-attrib">
        <span class="testimonial-name">{{name}}</span>
        <span class="testimonial-role">{{role}}</span>
      </figcaption>
    </figure>
    {{/items}}
  </div>
</div>
`;
// Exports
module.exports = code;